import React from 'react'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import Textarea from 'react-textarea-autosize'
import fetchJSON from 'lib/fetchJSON'
import { fm } from 'lib/localization'
import PropTypes from 'prop-types'
import { defineMessages, injectIntl } from 'react-intl'

export const SEND_MESSAGE_DIALOG = 'SEND_MESSAGE_DIALOG'

export const messages = defineMessages({
  subject: {
    id: 'SendMessage.subject',
    defaultMessage: 'Subject'
  },
  message: {
    id: 'SendMessage.message',
    defaultMessage: 'Message'
  },
  sendMessage: {
    id: 'SendMessage.sendMessage',
    defaultMessage: 'Send Message'
  },
  title: {
    id: 'SendMessage.title',
    defaultMessage: 'Send message to <b>{username}</b>'
  },
  error: {
    id: 'SendMessage.error',
    defaultMessage: 'An error occurred - please try again or contact support if the error persists'
  }
})

export class _SendMessage extends React.PureComponent {
  static propTypes = {
    toUser: PropTypes.object.isRequired
  }

  state = {
    subject: '',
    message: '',
    sendPending: false,
    error: null
  }

  onConfirm = (e) => {
    e && e.preventDefault()
    // sending messages is fire-and-forget unless it errors
    const { toUser, currentUserId, onRequestClose, intl } = this.props
    const { subject, message } = this.state
    this.setState({ sendPending: true })
    fetchJSON(`/users/${currentUserId}/conversations.json`, {
      recipient_id: toUser.id,
      subject,
      message
    }).then(() => {
      this.setState({ sendPending: false, error: null }, onRequestClose)
    }).catch(() => {
      this.seState({ sendPending: false, error: fm(intl, messages.error) })
    })
  }

  render () {
    const { message, subject, sendPending, error } = this.state
    const { toUser, onRequestClose, intl } = this.props

    return (
      <ConfirmationDialog
        primary
        title={fm(intl, messages.title, { username: toUser.name, b: (...c) => <b>{c}</b> })}
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.onConfirm}
        confirmPending={sendPending}
        confirmText='Send Message'>
        <form onSubmit={this.onConfirm}>
          <label>{fm(intl, messages.subject)}</label>
          <input autoFocus type='text' value={subject} onChange={e => this.setState({ subject: e.target.value })} />
          <label>{fm(intl, messages.message)}</label>
          <Textarea value={message} minRows={3} onChange={e => this.setState({ message: e.target.value })} />
          {error && <p>{error}</p>}
        </form>
      </ConfirmationDialog>
    )
  }
}

export const SendMessage = injectIntl(_SendMessage)
